<template>
  <CommonPages id="daily" title="Daily Trends" classs="daily">
    <div class="daily-container pc_padding">
      <header class="daily-header">
        <div class="period-toggle">
          <button v-for="p in ['daily', 'weekly', 'monthly']" :key="p" @click="setPeriod(p)" :class="{ active: period === p }">
            {{ p }}
          </button>
        </div>
        <h1 class="page-title">🇺🇸 US Trends</h1>
        <div v-if="trends.date" class="date-badge">
          <span :class="['dot', period === 'daily' ? 'green' : 'purple']"></span>
          <p>{{ trends.date }}</p>
        </div>
      </header>

      <div class="tabs-container">
        <div class="tabs">
          <button v-for="source in ['Twitter', 'TikTok', 'Reddit', 'Threads']" :key="source" @click="activeTab = source" :class="[{ active: activeTab === source }, source.toLowerCase()]">
            <span class="icon">{{ getSourceConfig(source).icon }}</span> {{ source }}
          </button>
        </div>
      </div>

      <div v-if="loading" class="loading">
        <p>{{ period === 'daily' ? 'ANALYZING TRENDS...' : 'FETCHING HISTORY...' }}</p>
      </div>
      <div v-else-if="error" class="error">
        <p>⚠️ Connection Error</p>
        <p>{{ error }}</p>
      </div>
      <div v-else class="trend-list-container">
        <div class="trend-list-card" :class="activeTab.toLowerCase()">
          <div class="trend-header">
            <div class="title-group">
              <span class="icon">{{ getSourceConfig(activeTab).icon }}</span>
              <h2>{{ activeTab }} Trends</h2>
            </div>
            <span class="count">Top {{ trends[activeTab] ? trends[activeTab].length : 10 }}</span>
          </div>

          <ul v-if="trends[activeTab] && trends[activeTab].length > 0" class="trend-list">
            <li v-for="item in trends[activeTab]" :key="item.rank" class="trend-item">
              <div class="rank">{{ item.rank }}</div>
              <div class="content">
                <div class="title-row">
                  <a :href="item.url" target="_blank" :title="item.title">{{ item.title }}</a>
                  <button class="ai-btn" @click="toggleExplanation(activeTab, item.rank)">
                    {{ expandedItems[`${activeTab}-${item.rank}`] ? '收起' : 'AI解读' }}
                  </button>
                </div>
                <div v-show="expandedItems[`${activeTab}-${item.rank}`]" class="explanation">
                  <div class="ai-badge">AI</div>
                  <p class="ai-title">智能深度解析</p>
                  <p class="ai-text">{{ item.explanation || "暂无解读信息。" }}</p>
                </div>
              </div>
            </li>
          </ul>
          <div v-else class="empty">
            <p>📭</p>
            <p>No trends available.</p>
          </div>
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js';
import CommonPages from '@/pages/components/pc_common.vue';
import axios from 'axios';
import '@/css/common.scss';
import '@/css/daily.scss';

export default {
  name: 'Daily',
  components: {
    CommonPages,
  },
  mixins: [common],
  data() {
    return {
      trends: { date: '', Twitter: [], Reddit: [], TikTok: [], Threads: [] },
      loading: true,
      error: null,
      expandedItems: {},
      activeTab: 'Twitter',
      period: 'daily',
    };
  },
  metaInfo() {
    return {
      title: 'Daily Trends | IAm.url',
      meta: [
        {
          name: 'description',
          content: 'Daily US Trends from Twitter, Reddit, TikTok, and Threads.',
        },
      ],
    };
  },
  watch: {
    period(newPeriod) {
      this.fetchTrends(newPeriod);
    }
  },
  mounted() {
    this.fetchTrends(this.period);
  },
  methods: {
    setPeriod(p) {
      this.period = p;
    },
    async fetchTrends(currentPeriod) {
      try {
        this.loading = true;
        this.error = null;
        // 这里的后端接口默认指向 daily/backend 启动后的服务地址，如果部署了后端需要替换为实际地址
        const endpoint = currentPeriod === 'daily' 
          ? 'http://127.0.0.1:8000/api/trends' 
          : `http://127.0.0.1:8000/api/trends/historical?period=${currentPeriod}`;
        
        const response = await axios.get(endpoint);
        this.trends = response.data;
        this.loading = false;
      } catch (error) {
        console.error('Error fetching trends:', error);
        this.error = 'Failed to load data. Please try again later.';
        this.loading = false;
      }
    },
    toggleExplanation(source, rank) {
      const key = `${source}-${rank}`;
      this.$set(this.expandedItems, key, !this.expandedItems[key]);
    },
    getSourceConfig(source) {
      switch (source) {
        case 'Twitter': return { icon: '🐦' };
        case 'Reddit': return { icon: '🤖' };
        case 'TikTok': return { icon: '🎵' };
        case 'Threads': return { icon: '🧵' };
        default: return { icon: '✨' };
      }
    }
  }
};
</script>
